import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
// import Typography from '@material-ui/core/Typography';
import { useDataProvider, GetListResult, useNotify } from 'react-admin';
import {
  ContractorDto,
  JobPhaseContractorDto,
  JobPhaseTimelineResponseDto,
} from '@vatos-pas/common';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PHASE_CONTRACTOR_LIST_LIMIT } from 'utils/phaseUtils';
import { axiosInstance } from 'services/http';
import { extractErrorMessage } from 'utils';
import { contractorFilterForPhase } from 'utils/contractorFilter';

export const ContractorChangeDialog = (props: any) => {
  const [contractors, setContractors] = useState<ContractorDto[]>([]);
  const [contractorSelected, setContractorSelected] = useState<string>('');
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const phaseType = props.selectedJobPhase?.phaseType;

  const onChangeContractor = (event: any) => {
    setContractorSelected(event.target.value);
  };

  const getContractors = async () => {
    const contractorData: GetListResult<ContractorDto> =
      await dataProvider.getList('contractor', {
        filter: {
          ...contractorFilterForPhase(phaseType, props.regionId, {
            highCeiling: Boolean(props.job?.job?.highCeiling),
          }),
          $join: [{ field: 'contractorRegions' }],
        },
        pagination: { page: 1, perPage: PHASE_CONTRACTOR_LIST_LIMIT },
        sort: { field: 'name', order: 'ASC' },
      });
    if (contractorData.data) {
      setContractors(contractorData.data);
    } else {
      throw new Error('Job phases not found');
    }
  };

  useEffect(() => {
    if (props.selectedJobPhase) {
      getContractors();
    }
  }, [props.selectedJobPhase]);

  const onConfirmContractor = async () => {
    if (!contractorSelected) return;

    try {
      // Single request: the API decides whether the contractor lives on the
      // phase or on its bump log (timesheet subdivisions) and returns the
      // timeline rows, so no GET job-phase-bump and no refetch are needed.
      const payload: JobPhaseContractorDto = { contractorId: contractorSelected };
      const { data } = await axiosInstance.patch<JobPhaseTimelineResponseDto>(
        `job-phase/${props.selectedJobPhase.id}/contractor`,
        payload,
      );

      notify('Contractor Assigned!');
      props.handleClose();
      props.onTimelinePayload(data);
    } catch (error: any) {
      notify(
        extractErrorMessage(error, 'Failed to change the contractor'),
        'warning',
      );
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title-"
      aria-describedby="alert-dialog-description9"
    >
      <DialogTitle id="alert-dialog-ti9tle">Change Contractor</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-desc9ription">
          <Box display="flex">
            <Select
              onChange={onChangeContractor}
              labelId={`custom-reference-contractor`}
              id={`reference-contractor`}
              fullWidth
              value={contractorSelected}
              disabled={props.isLaborCoordinator}
            >
              {contractors.map((item: ContractorDto) => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  data-item={item.id}
                  data-name={item.name}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </DialogContentText>
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button onClick={props.handleClose} color="primary">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirmContractor}
            color="primary"
            disabled={!contractorSelected}
          >
            Save
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContractorChangeDialog;